var style = {
    cardHeader: {
        borderRadius: "3px",
        padding: "1rem 15px",
        marginLeft: "15px",
        marginRight: "15px",
        marginTop: "-30px",
        border: "0",
        marginBottom: "0"
    },
    cardHeaderPlain: {
        marginLeft: "0px",
        marginRight: "0px"
    },
    primaryCardHeader: {
        color: "#fff",
        background: "linear-gradient(60deg, #003663, #005885)",
        // background: "linear-gradient(60deg, #ab47bc, #8e24aa)",
        boxShadow: "0 12px 20px -10px rgba(0, 36, 63, 0.28), 0 4px 20px 0px rgba(0, 0, 0, 0.12), 0 7px 8px -5px rgba(0, 58, 85, 0.2)"
        // boxShadow: "0 12px 20px -10px rgba(156, 39, 176, 0.28), 0 4px 20px 0px rgba(0, 0, 0, 0.12), 0 7px 8px -5px rgba(156, 39, 176, 0.2)"
    },
    warningCardHeader: {
        color: "#fff",
        background: "linear-gradient(60deg, #ffa726, #fb8c00)",
        boxShadow: "0 12px 20px -10px rgba(255, 152, 0, 0.28), 0 4px 20px 0px rgba(0, 0, 0, 0.12), 0 7px 8px -5px rgba(255, 152, 0, 0.2)"
    }
};
export default style;